import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from 'react';
import Layout from '../components/layout';
import SEO from "../components/seo";
import LogoImage from '../images/thumnail_blog_default.png';

// Function to decode HTML entities
const decodeHtmlEntities = (text) => {
  if (typeof document !== 'undefined') {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }
  // Fallback for SSR
  return text.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#039;/g, "'");
};

const BlogPage = (props) => {
  const POST_PER_PAGE = 50;
  const [selectedCategory, setSelectedCategory] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  //
  console.log('BlogPage props:', props);
  const ALL_POSTS = props.pageContext.posts;
  const allPostLength = ALL_POSTS.length;
  // // get category name
  // let categories = new Set();
  // ALL_POSTS.forEach(p => {
  //   p.categories.nodes.forEach(c => categories.add(c.name));
  // });
  // categories = Array.from(categories);
  // // alphabet
  // categories.sort();
  //
  const isDisabledPrevious = () => {
    return currentIndex === 0;
  }

  const isDisabledNext = () => {
    return (currentIndex + POST_PER_PAGE) >= allPostLength;
  }

  const isPaging = () => {
    return selectedCategory === '';
  }

  const jump = (direction) => {
    if (direction) {
      setCurrentIndex(currentIndex + POST_PER_PAGE);
    } else {
      setCurrentIndex(currentIndex - POST_PER_PAGE);
    }
  }
  const seo = {
    metaDesc: 'Blog - Inventiv.org'
  }

  // Functions support for Wordpress API POST Format
  const getImageUrl = (post) => {
    // Try to get featured image from WordPress API structure
    if (post._embedded && post._embedded["wp:featuredmedia"] && post._embedded["wp:featuredmedia"][0] && post._embedded["wp:featuredmedia"][0].source_url) {
      return post._embedded["wp:featuredmedia"][0].media_details.sizes.medium.source_url;
    }

    // Try alternative structure
    if (post.featured_media_url) {
      return post.featured_media_url;
    }

    // Fallback to default image
    return LogoImage;
  };

  const getPostTitle = (post) => {
    if (post.title && typeof post.title === 'object' && post.title.rendered) {
      return decodeHtmlEntities(post.title.rendered);
    }
    if (typeof post.title === 'string') {
      return decodeHtmlEntities(post.title);
    }
    return 'Untitled';
  };

  const getPostExcerpt = (post) => {
    if (post.excerpt && typeof post.excerpt === 'object' && post.excerpt.rendered) {
      return post.excerpt.rendered.replace(/<[^>]+>/g, "");
    }
    if (post.excerpt && typeof post.excerpt === 'string') {
      return post.excerpt.replace(/<[^>]+>/g, "");
    }
    return "Read more to discover the full content of this post...";
  };

  useEffect(() => {
    document?.body.classList.add('no-home');
  }, []);

  return (
    <Layout>
      <SEO title="Supporting inventors world-wide - Inventiv.org" canonical='/blog' seo={seo} />
      <div class="sub-banner main-banner">
        <div class="container">
          <div class="breadcrumb-area">
            <h1>Blogs</h1>
          </div>
        </div>
      </div>

      <div class="blog-section content-area">
        <div class="container">
          <div class="row">
            {
              ALL_POSTS.map((post, index) =>
                ((isPaging() && ((index >= currentIndex) && (index < (currentIndex + POST_PER_PAGE))))) ?
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="blog">
                      <div class="blog-photo">
                        <img src={getImageUrl(post)} alt={getPostTitle(post)} />
                      </div>
                      <div class="detail">
                        <h3>
                          <a href={`/blog/${post.slug}`}>{getPostTitle(post)}</a>
                        </h3>
                        <div class="post-meta clearfix">
                          <span><a href="/"><i class="fa fa-user"></i></a>INVENTIV.ORG</span>
                        </div>
                        <p>
                          {getPostExcerpt(post)}
                        </p>
                        <a href={`/blog/${post.slug}`} class="d-clr" aria-label={getPostTitle(post)}>Read more</a>
                      </div>
                    </div>
                  </div>
                  :
                  null
              )
            }
          </div>

          {/* Paging */}
          {isPaging() && (
            <section className="pagination-area text-center">
              <div className="row">
                <div className="col-12">
                  <nav aria-label="Blog pagination">
                    <ul className="pagination justify-content-center">
                      {/* Previous Button */}
                      <li className={`page-item ${isDisabledPrevious() ? 'disabled' : ''}`}>
                        <a 
                          className="page-link" 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isDisabledPrevious()) jump(false);
                          }}
                          aria-label="Previous page"
                          tabIndex={isDisabledPrevious() ? -1 : 0}
                        >
                          <span aria-hidden="true">&laquo;</span> Previous
                        </a>
                      </li>

                      {/* Page Numbers */}
                      {Array.from({ length: Math.ceil(allPostLength / POST_PER_PAGE) }, (_, i) => {
                        const pageNumber = i + 1;
                        const isCurrentPage = currentIndex === i * POST_PER_PAGE;
                        
                        return (
                          <li key={i} className={`page-item ${isCurrentPage ? 'active' : ''}`}>
                            <a 
                              className="page-link" 
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentIndex(i * POST_PER_PAGE);
                              }}
                              aria-label={`Go to page ${pageNumber}`}
                              aria-current={isCurrentPage ? 'page' : undefined}
                            >
                              {pageNumber}
                            </a>
                          </li>
                        );
                      })}

                      {/* Next Button */}
                      <li className={`page-item ${isDisabledNext() ? 'disabled' : ''}`}>
                        <a 
                          className="page-link" 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isDisabledNext()) jump(true);
                          }}
                          aria-label="Next page"
                          tabIndex={isDisabledNext() ? -1 : 0}
                        >
                          Next <span aria-hidden="true">&raquo;</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </Layout>
  )
};

// export const query = graphql`
//   {
//     allWpPost {
//       nodes {
//         excerpt
//         content
//         id
//         uri
//         title
//         slug
//         date(fromNow: true)
//         categories {
//           nodes {
//             name
//           }
//       }
//       featuredImage {
//           node {
//             localFile {
//               childImageSharp {
//                 gatsbyImageData(width: 1920, placeholder: TRACED_SVG, height: 100)
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `

export default BlogPage;